var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('headerNav',{class:{scollBack: _vm.scrolled,color_white:_vm.scrolled}}),_c('returnTop'),_c('router-view'),_c('footerNav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }